import { Card, CardContent, CardHeader, LabelValueList, Typography, useRouter } from '@forgeglobal/design-framework'
import { FundingRoundFragment, useOpportunityCompanyFinancingQuery } from 'graphql/bindings/AdminBindings'
import { formatAbbreviatedMoney, formatAbbreviatedNumber, formatSharePrice } from 'util/NumberUtils'
import { monthYear } from 'util/DateUtils'
import React from 'react'

const LastRoundStageValuation: React.FC<{ lastRound: FundingRoundFragment }> = ({ lastRound }) => (
  <React.Fragment>
    {lastRound.stage && (
      <Typography variant="body1" align="right">
        {lastRound.stage}
      </Typography>
    )}
    {lastRound.valuation && (
      <Typography variant="body1" align="right">
        {formatAbbreviatedMoney(lastRound.valuation)} valuation
      </Typography>
    )}
  </React.Fragment>
)

const LastRoundShares: React.FC<{ lastRound: FundingRoundFragment }> = ({ lastRound }) => (
  <React.Fragment>
    {lastRound.price_per_share && (
      <Typography variant="body1" align="right">
        {formatSharePrice(lastRound.price_per_share)} per share
      </Typography>
    )}
    {lastRound.est_num_shares && (
      <Typography variant="body1" align="right">
        {formatAbbreviatedNumber(lastRound.est_num_shares)} shares
      </Typography>
    )}
  </React.Fragment>
)

const LastRoundPanel: React.FC<{ lastRound?: FundingRoundFragment | null }> = ({ lastRound }) => (
  <Card>
    <CardHeader title="Last Round Issuer Financing" />
    <CardContent>
      <LabelValueList
        items={[
          {
            label: 'Date of last round',
            value: lastRound && monthYear(lastRound.round_date),
            isEmpty: !(lastRound && lastRound.round_date),
          },
          {
            label: 'Last funding round',
            value: lastRound && <LastRoundStageValuation lastRound={lastRound} />,
            isEmpty: !(lastRound && (lastRound.stage || lastRound.valuation)),
          },
          {
            label: 'Shares',
            value: lastRound && <LastRoundShares lastRound={lastRound} />,
            isEmpty: !(lastRound && (lastRound.price_per_share || lastRound.est_num_shares)),
          },
        ]}
      />
    </CardContent>
  </Card>
)

const LastRoundDetails: React.FC = () => {
  const { match } = useRouter<{ id: string }>()
  const { data } = useOpportunityCompanyFinancingQuery({ variables: { opportunityId: match.params.id } })
  const lastRound = data?.opportunity?.company?.last_round

  return <LastRoundPanel lastRound={lastRound} />
}

export { LastRoundDetails, LastRoundPanel }
